import { Outlet, Link } from "react-router-dom"
import { Button } from "../../components/buttons"

/*
Props:
*/

const Incentives = () => {
  return (
    <div>
      Incentives
      <Button link="../viewJob"/>
    </div>
  )
}

export default Incentives